<template>
  <div class="supplier-form-page">
    <!-- 顶部导航 -->
    <header class="back-header">
      <div class="back-btn" @click="goBack">←</div>
      <h1>{{ isEdit ? $t('wholesaler.purchase.SupplierForm.page_title_edit') : $t('wholesaler.purchase.SupplierForm.page_title_new') }}</h1>
      <div style="flex: 1;"></div>
    </header>

    <div class="page-content">
      <!-- 基本信息 -->
      <div class="info-section">
        <h3>{{ $t('wholesaler.purchase.SupplierForm.line13_text') }}</h3>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line15_text') }} <span class="required">*</span></label>
          <input type="text" v-model="form.name" :placeholder="$t('wholesaler.purchase.SupplierForm.line16_placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line19_text') }}</label>
          <input type="text" v-model="form.contactPerson" :placeholder="$t('wholesaler.purchase.SupplierForm.line20_placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line23_text') }}</label>
          <input type="tel" v-model="form.phone" :placeholder="$t('wholesaler.purchase.SupplierForm.line24_placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line27_text') }}</label>
          <div class="address-input-row">
            <input type="text" v-model="form.address" :placeholder="$t('wholesaler.purchase.SupplierForm.line29_placeholder')" />
            <button type="button" class="btn-map-pick" @click="showMapPicker = true">{{ $t('wholesaler.purchase.SupplierForm.line30_text') }}</button>
          </div>
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line34_text') }}</label>
          <textarea v-model="form.remark" :placeholder="$t('wholesaler.purchase.SupplierForm.line35_placeholder')" rows="2"></textarea>
        </div>
      </div>

      <!-- 银行收款账户 -->
      <div class="info-section bank-section">
        <h3>{{ $t('wholesaler.purchase.SupplierForm.line41_text') }}</h3>
        <p class="section-hint">{{ $t('wholesaler.purchase.SupplierForm.line42_text') }}</p>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line44_text') }}</label>
          <input type="text" v-model="form.bankName" :placeholder="$t('wholesaler.purchase.SupplierForm.line45_placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line48_text') }}</label>
          <input type="text" v-model="form.bankAccountName" :placeholder="$t('wholesaler.purchase.SupplierForm.line49_placeholder')" />
        </div>
        <div class="form-item">
          <label>{{ $t('wholesaler.purchase.SupplierForm.line52_text') }}</label>
          <input type="text" v-model="form.bankAccountNumber" :placeholder="$t('wholesaler.purchase.SupplierForm.line53_placeholder')" />
        </div>
      </div>

      <!-- 保存按钮 -->
      <div class="save-section">
        <button class="btn-save" @click="submit">{{ isEdit ? $t('wholesaler.purchase.SupplierForm.btn_update') : $t('wholesaler.purchase.SupplierForm.btn_save') }}</button>
      </div>
    </div>

    <!-- Toast -->
    <div v-if="showToast" class="toast">{{ toastMessage }}</div>

    <!-- 地图选点 -->
    <MapPicker v-if="showMapPicker" @confirm="onMapConfirmed" @cancel="showMapPicker = false" />
  </div>
</template>

<script>
import { createSupplier, updateSupplier } from '@/api/purchase'
import { getWholesalerId } from '@/utils/wholesaler'
import MapPicker from '@/components/MapPicker.vue'

export default {
  name: 'SupplierForm',
  components: { MapPicker },

  data() {
    return {
      isEdit: false,
      editId: null,
      showMapPicker: false,
      showToast: false,
      toastMessage: '',
      form: {
        name: '',
        contactPerson: '',
        phone: '',
        address: '',
        remark: '',
        bankName: '',
        bankAccountName: '',
        bankAccountNumber: ''
      }
    }
  },

  computed: {
    wholesalerId() {
      return getWholesalerId()
    }
  },

  created() {
    const query = this.$route.query
    if (query.id) {
      this.isEdit = true
      this.editId = query.id
      this.form = {
        name: query.name || '',
        contactPerson: query.contactPerson || '',
        phone: query.phone || '',
        address: query.address || '',
        remark: query.remark || '',
        bankName: query.bankName || '',
        bankAccountName: query.bankAccountName || '',
        bankAccountNumber: query.bankAccountNumber || ''
      }
    }
  },

  methods: {
    onMapConfirmed(location) {
      this.form.address = location.address
      this.showMapPicker = false
    },

    async submit() {
      if (!this.form.name.trim()) {
        this.showToastMsg(this.$t('wholesaler.purchase.SupplierForm.toast_name_required'))
        return
      }
      try {
        if (this.isEdit) {
          await updateSupplier(this.editId, this.form)
          this.showToastMsg(this.$t('wholesaler.purchase.SupplierForm.toast_update_success'))
        } else {
          await createSupplier({
            ...this.form,
            wholesalerId: this.wholesalerId,
            status: 'ACTIVE'
          })
          this.showToastMsg(this.$t('wholesaler.purchase.SupplierForm.toast_save_success'))
        }
        setTimeout(() => { this.goBack() }, 1000)
      } catch (e) {
        this.showToastMsg(this.$t('wholesaler.purchase.SupplierForm.toast_save_failed'))
      }
    },

    goBack() {
      this.$router.go(-1)
    },

    showToastMsg(message) {
      this.toastMessage = message
      this.showToast = true
      setTimeout(() => { this.showToast = false }, 2500)
    }
  }
}
</script>

<style scoped>
.supplier-form-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.back-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
}

.back-header h1 {
  flex: 1;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin-left: 12px;
}

.page-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 80px;
}

.info-section {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.info-section h3 {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 700;
  color: #333;
}

.bank-section {
  border: 2px solid #38bdf8;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
}

.bank-section h3 {
  color: #1e40af;
}

.section-hint {
  font-size: 12px;
  color: #64748b;
  margin: -8px 0 16px 0;
}

.form-item {
  margin-bottom: 16px;
}

.form-item:last-child {
  margin-bottom: 0;
}

.form-item label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
}

.required {
  color: #f44336;
}

.form-item input,
.form-item textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-size: 13px;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-item input:focus,
.form-item textarea:focus {
  border-color: #ff6b35;
}

.form-item textarea {
  resize: vertical;
  min-height: 60px;
}

.address-input-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

.address-input-row input {
  flex: 1;
}

.btn-map-pick {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.save-section {
  padding: 12px;
  background-color: #fff;
  margin: 12px;
  border-radius: 12px;
}

.btn-save {
  width: 100%;
  padding: 12px;
  border: none;
  background-color: #ff6b35;
  color: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.btn-save:active {
  opacity: 0.9;
}

.toast {
  position: fixed;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.8);
  color: #fff;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 13px;
  z-index: 2000;
}
</style>
